import { render } from "./SeeMoreButton.vue?vue&type=template&id=bfb2732a&scoped=true"
import script from "./SeeMoreButton.vue?vue&type=script&lang=js"
export * from "./SeeMoreButton.vue?vue&type=script&lang=js"

import "./SeeMoreButton.vue?vue&type=style&index=0&id=bfb2732a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfb2732a"]])

export default __exports__